import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, Grid, Skeleton, Theme, Typography, useTheme } from "@mui/material";
import { checkImageExists, getAbbreviatedName, isRMLikeRole } from "../../../../utils/utilityFunctions";
import { Form, Formik } from "formik";
import { MFTextField } from "../../../../lib/formik";
import LoadingButton from "@mui/lab/LoadingButton";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import * as Yup from 'yup';
import { leadingZeroDigitRegex, numberRegex } from "../../../../utils/regex";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import { MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from "../../../../utils/constant";
import { pauseSipTransaction, renewedPauseSipTransaction } from "../../../../redux-store/actions/investorProfile";
import { PauseSipTransactionResponseBody } from "../../../../redux-store/types/investorProfile";
import { GenerateOtpResponseBody } from "../../../../redux-store/types/cart";
import { generateOtp } from "../../../../redux-store/actions/cart";
import { showError } from "../../../../redux-store/actions/auth";
import { ConfirmationDialog, ErrorDialog, SuccessDialog } from "./CommonDialogs";
import { getInvestmentUserDetails } from "../../../../redux-store/actions/funds";
import { GetInvestmentUserDetails } from "../../../../redux-store/types/api-types";
import { EmailIcon, FailureIcon, Phoneicon } from "../../../../assets/SvgIcons";
import TransactionsDocumentUpload from "../../../../lib/TransactionsDocumentUpload";


interface InitialValues {
    noOfInstallments: string;
    documents?: { documentId: string; documentType: string }[];
}


const validationSchema = (role: string, selectedPortfolioObj: Record<string, any>) => Yup.object().shape({
    noOfInstallments: Yup.string()
        .required('Required Field')
        .test('is-valid-number', 'No. of Installments should be a valid number', function (value) {
            return numberRegex.test(`${value ?? ""}`);
        })
        .test('minimum-installments', 'No. of Installments should be greater than or equal to 1', function (value) {
            return Number(value ?? "") >= 1;
        })
        .test('no-leading-zeros', 'No. of Installments should be a valid number', function (value) {
            return !leadingZeroDigitRegex.test(value ?? "");
        }),
    ...(
       isRMLikeRole(role) &&
        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
    ) ? {
        documents: Yup.array().of(
            Yup.object().shape({
                documentId: Yup.string(),
                documentType: Yup.string()
            })
        )
    } : {}

    // handle validation for documents
})



export default function PauseSIP(): JSX.Element {
    const history = useHistory();
    const dispatch = useDispatch();
    const { palette } = useTheme();

    const { selectedPlanInfo = {}, clientCode = '', rmId = '' } = history.location.state as unknown as { selectedPlanInfo: { [key: string]: any }, clientCode: string; rmId: string }
    const { role = '' } = useSelector((state: RootStateType) => state.auth);

    const amcIds = ['BDOTR', 'BPIAMC']

    const checkAmcId = amcIds.includes(selectedPlanInfo?.amcId ?? "") ? (selectedPlanInfo?.amcId ?? "")?.toLowerCase() : (selectedPlanInfo?.amcId ?? "");
    const { selectedPortfolio = { label: '', value: '' }, selectedPortfolioObj } = useSelector((state: RootStateType) => state.selectedPortfiolio)

    const { investorClientId = "" } = useSelector((store: RootStateType) => store.id);
    const [isPlanDetailsLoading, setPlanDetailsLoading] = useState<boolean>(false);
    const [pauseLoading, setPauseLoading] = useState<boolean>(false);
    const [otpLoading, setOtpLoading] = useState<boolean>(false);
    const [otpDetails, setOtpDetails] = useState<GenerateOtpResponseBody>({} as GenerateOtpResponseBody);
    const [userDetails, setUserDetails] = useState<{
        name: string;
        status: string;
        mobile: string;
        email: string;
        accountType: string;
    }>({
        name: "",
        status: "",
        mobile: "",
        email: "",
        accountType: ""
    })
    const [sipDialogStatus, setSipDialogStatus] = useState<{
        isPauseConfirm: boolean;
        isPauseSipSuccessOpen: boolean;
        isPauseSipErrorOpen: boolean;
        isCancelSipConfirmationOpen: boolean;
    }>({
        isPauseConfirm: false,
        isPauseSipSuccessOpen: false,
        isPauseSipErrorOpen: false,
        isCancelSipConfirmationOpen: false
    })
    const [pauseCancelResponse, setPauseCancelResponse] = useState<{ [key: string]: any }>({})
    const [formikValues, setFormikValues] = useState<{ [key: string]: any }>({})
    const [userDetailsLoading, setUserDetailsLoading] = useState<boolean>(false);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);

    const initialValues: InitialValues = {
        noOfInstallments: "",
        ...((
            isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: [{
                documentId: "",
                documentType: ""
            }]
        } : {}
        )
    }



    const handleOtpCase = async (cartId: string, token: string) => {
        const payload = {
            order_cart_id: cartId,
            token
        }
        try {
            setOtpLoading(true);
            const response = await (dispatch(generateOtp(payload)) as unknown as Promise<GenerateOtpResponseBody>)
            setOtpDetails(response);
            if (!response?.isSuccess) return;
            history.push(`otp-screen`, {
                paymentId: response?.token ?? "",
                cartId: response?.cartId ?? '',
                id: response?.id ? `${response?.id}` : "",
                message: response?.message ?? "",
            })
        } catch (e) {
            console.log('error', e);
            dispatch(showError(otpDetails?.message ?? ''))
        } finally {
            setOtpLoading(false);
        }
    }
    const handleConfirmPause = async () => {
        const payload = {
            clientCode,
            accountType: MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()],
            orderDetails: [
                {
                    clientCode,
                    registrationType: "XSIP",
                    registrationNumber: selectedPlanInfo?.registrationNo,
                    modificationType: "PAUSE",
                    noOfInstallments: formikValues?.noOfInstallments,
                    rmId,
                    portfolioId: selectedPortfolio?.value,
                    amcId: selectedPlanInfo?.amcId,
                    fromSchemeName: selectedPlanInfo?.schemeName,
                    fromSchemeCode: selectedPlanInfo?.scheme,
                    isRecommended: ((isRMLikeRole(role?.toLowerCase()))),
                    isDiy: !((isRMLikeRole(role?.toLowerCase()))),
                    folioNo: selectedPlanInfo?.folioNo,
                    portfolioName: selectedPortfolio?.label
                }
            ],
            ...(isRMLikeRole(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ? {
                    documents: formikValues.documents?.map((doc: { documentId: string; documentType: string }) => ({
                        documentId: doc?.documentId,
                        documentType: doc?.documentType
                    }))
                }
                :
                {}
            )
        }

        try {
            setPauseLoading(true);
            const response = await (dispatch(renewedPauseSipTransaction(payload)) as unknown as Promise<PauseSipTransactionResponseBody>)
            setSipDialogStatus(prev => ({
                ...prev,
                isPauseConfirm: false
            }))
            if (response?.isSuccess && response?.isPaymentFlow) {
                setPauseCancelResponse(response)
                // handleOtpCase(response?.cartId ?? "", response?.token ?? "")
                if (response?.otp_response?.isSuccess) {
                    history.push(`otp-screen`, {
                        paymentId: response?.token ?? "",
                        cartId: response?.cartId ?? '',
                        id: response?.otp_response?.id ? `${response?.otp_response?.id}` : "",
                        message: response?.otp_response?.message ?? "",
                    })
                } else if (!response?.otp_response?.isSuccess) {
                    dispatch(showError(response?.otp_response?.message ?? ""))
                }
            }
            if (response?.isSuccess && !response?.isPaymentFlow) {
                setPauseCancelResponse(response)

                setSipDialogStatus(prevState => ({
                    ...prevState,
                    isPauseSipSuccessOpen: true
                }))
            }
            if (!response?.isSuccess) {
                setPauseCancelResponse(response)

                setSipDialogStatus(prevState => ({
                    ...prevState,
                    isPauseSipErrorOpen: true
                }))
            }
        } catch (e) {
            console.error('e', e);
        } finally {
            setPauseLoading(false);
        }


        // setPauseSipFormData({ noOfInstallments: "" })
    }
    const handleSubmit = async (values: InitialValues) => {
        if ((
            isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (values?.documents?.length === 1 && (values?.documents[0]?.documentId === '' || values?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }
        setSipDialogStatus(prevState => ({
            ...prevState,
            isPauseConfirm: true
        }));
        setFormikValues(values);
    }

    const handleSuccessPauseSIP = () => {
        setSipDialogStatus(prev => ({
            ...prev,
            isPauseSipSuccessOpen: false
        }))
        history.push('/dashboard');
    }

    const handleErrorPauseSIP = () => {
        setSipDialogStatus(prev => ({
            ...prev,
            isPauseSipErrorOpen: false
        }))
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                setUserDetailsLoading(true)

                const response = await (dispatch(getInvestmentUserDetails({
                    clientCode: (isRMLikeRole(role?.toLowerCase())) ? clientCode ?? "" : investorClientId,
                    portfolioId: selectedPortfolio?.value ?? ""
                })) as unknown as Promise<GetInvestmentUserDetails>)

                setUserDetails({
                    name: response?.name ?? "",
                    status: response?.status ?? "",
                    mobile: response?.mobile ?? "",
                    email: response?.email ?? "",
                    accountType: response?.accountType ?? ""
                })

            } catch (error) {
                console.log((error as Error)?.message);
            } finally {
                setUserDetailsLoading(false)
            }
        }
        fetchUserDetails();
    }, [])



    return (
        <>
            <Formik
                validationSchema={validationSchema(role, selectedPortfolioObj)}
                initialValues={initialValues}
                onSubmit={handleSubmit}
            >
                {
                    ({ values }) => {
                        return (
                            <>
                                <Form>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={7}>
                                            <Box sx={(theme: Theme) => ({
                                                borderRadius: "20px",
                                                padding: "35px 30px",
                                                backgroundColor: theme.palette.common.white,
                                                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                            })}>
                                                <Box
                                                    sx={(theme: Theme) => ({
                                                        padding: "10px 0px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        borderBottom: `1px solid ${theme.palette.text.secondary}B2`
                                                    })}
                                                >
                                                    <Typography
                                                        variant="h2"
                                                        sx={(theme: Theme) => ({
                                                            lineHeight: "25px",
                                                            letterSpacing: "0.01px",
                                                            color: theme.palette.text.primary
                                                        })}
                                                    >
                                                        Pause SIP
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ padding: "30px 0px" }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            columnGap: "15px",
                                                            // alignItems: "flex-start"
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                borderRadius: "50%",
                                                                overflow: "hidden",
                                                                width: "50px",
                                                                height: "50px",
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            <Box
                                                                component='img'
                                                                src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                                                                alt={selectedPlanInfo?.schemeName ?? ""}
                                                                sx={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "contain",
                                                                    flexShrink: 0,
                                                                }}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                flex: 1,
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                rowGap: "7px"
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body_600"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "22.5px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.primary
                                                                })}
                                                            >
                                                                {selectedPlanInfo?.schemeName ?? ""}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Box
                                                        sx={(theme: Theme) => ({
                                                            marginTop: "30px",
                                                            paddingBottom: "10px",
                                                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                                        })}
                                                    >
                                                        <Box sx={{ width: "50%" }}>
                                                            <MFTextField
                                                                autoFocus
                                                                name="noOfInstallments"
                                                                label="No. of Installments"
                                                                placeholder="Enter No. of Installments"
                                                                disabled={isPlanDetailsLoading}
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset>legend": {
                                                                            fontSize: { xs: "0.6em", md: "0.7em", lg: "0.78em" }
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ marginTop: "25px" }}>
                                                        <Typography
                                                            variant="body_500"
                                                            sx={(theme: Theme) => ({
                                                                fontWeight: 600,
                                                                lineHeight: "20px",
                                                                letterSpacing: "0.02px",
                                                                color: theme.palette.primary[500]
                                                            })}
                                                        >
                                                            Note:
                                                            <Typography
                                                                component="span"
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    fontWeight: 400,
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    marginLeft: "8px"
                                                                })}
                                                            >
                                                                SIP installments will resume automatically once the pause period is over
                                                            </Typography>
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            marginTop: "25px",
                                                            columnGap: "25px",
                                                        }}
                                                    >
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={5}>
                                            <>
                                                {isRMLikeRole(role) &&
                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                    &&
                                                    (
                                                        <Box
                                                            sx={(theme: Theme) => ({
                                                                background: theme.palette.background.paper,
                                                                padding: '20px',
                                                                borderRadius: '20px',
                                                                marginBottom: "20px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                flexDirection: "column"
                                                            })}
                                                            boxShadow={1}
                                                        >
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: `${theme.palette.text.secondary}B2`,
                                                                })}
                                                            >
                                                                You can add minimum 1 attachment and maximum 5 attachments
                                                            </Typography>
                                                            <Typography
                                                                variant='body_400'
                                                                sx={(theme: Theme) => ({
                                                                    color: theme.palette.text.primary,
                                                                    alignSelf: "flex-start",
                                                                    marginTop: "10px"
                                                                })}
                                                            >
                                                                Documents Uploaded: {
                                                                    values?.documents?.filter((obj: {
                                                                        documentId: string;
                                                                        documentType: string;
                                                                    }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                                }
                                                            </Typography>
                                                            <Button
                                                                sx={(theme: Theme) => ({
                                                                    ...theme.typography.body_500,
                                                                    color: theme.palette.primary[500],
                                                                    padding: "5px",
                                                                    fontWeight: 600,
                                                                    marginTop: "15px"
                                                                })}
                                                                onClick={handleDocumentUploadDialogOpen}
                                                            // disabled={isLoading || apiLoading}
                                                            >
                                                                Upload Documents
                                                            </Button>
                                                        </Box>
                                                    )}
                                                <Box
                                                    sx={(theme: Theme) => ({
                                                        flex: 1,
                                                        borderRadius: "20px",
                                                        padding: "25px 30px 30px 30px",
                                                        backgroundColor: theme.palette.common.white,
                                                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                                                        height: "fit-content"
                                                    })}
                                                >
                                                    <Box sx={{ mb: 2 }}>
                                                        {userDetailsLoading && (
                                                            <Box
                                                                sx={(theme: Theme) => ({
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "35px",
                                                                    paddingBottom: "35px",
                                                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                                                })}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        columnGap: "15px"
                                                                    }}
                                                                >
                                                                    <Skeleton
                                                                        component="div"
                                                                        variant="rounded"
                                                                        sx={{
                                                                            borderRadius: "50%",
                                                                            width: { xs: "45px", md: "50px", lg: "58px" },
                                                                            height: { xs: "45px", md: "50px", lg: "58px" },
                                                                        }}
                                                                    />
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            rowGap: "5px",
                                                                            width: "100%"
                                                                        }}
                                                                    >
                                                                        <Skeleton
                                                                            component="div"
                                                                            sx={(theme: Theme) => ({
                                                                                ...theme.typography.h2,
                                                                                width: "100%"
                                                                            })}
                                                                        />
                                                                        <Skeleton
                                                                            component="div"
                                                                            sx={(theme: Theme) => ({
                                                                                ...theme.typography.body_500,
                                                                                width: "50%"
                                                                            })}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        rowGap: "12px"
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            columnGap: "11px",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        <EmailIcon />
                                                                        <Skeleton
                                                                            component="div"
                                                                            sx={(theme: Theme) => ({
                                                                                ...theme.typography.body_500,
                                                                                width: "50%",
                                                                            })}
                                                                        />
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            columnGap: "11px",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        <Phoneicon />
                                                                        <Skeleton
                                                                            component="div"
                                                                            sx={(theme: Theme) => ({
                                                                                ...theme.typography.body_500,
                                                                                width: "50%",
                                                                            })}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        )}
                                                        {!userDetailsLoading && (
                                                            <Box
                                                                sx={(theme: Theme) => ({
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    rowGap: "35px",
                                                                    paddingBottom: "35px",
                                                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                                                                })}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        columnGap: "15px"
                                                                    }}
                                                                >
                                                                    <Avatar
                                                                        sx={(theme: Theme) => ({
                                                                            backgroundColor: theme.palette.primary[50],
                                                                            width: { xs: "45px", md: "50px", lg: "58px" },
                                                                            height: { xs: "45px", md: "50px", lg: "58px" },
                                                                        })}
                                                                    >
                                                                        <Typography
                                                                            variant="h3"
                                                                            sx={(theme: Theme) => ({
                                                                                lineHeight: "30px",
                                                                                letterSpacing: "0.02px",
                                                                                color: theme.palette.primary[500],
                                                                            })}
                                                                        >
                                                                            {getAbbreviatedName(userDetails?.name ?? "")}
                                                                        </Typography>
                                                                    </Avatar>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            rowGap: "5px"
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="h2"
                                                                            sx={(theme: Theme) => ({
                                                                                lineHeight: "25px",
                                                                                letterSpacing: "0.01px",
                                                                                color: theme.palette.text.primary
                                                                            })}
                                                                        >
                                                                            {userDetails?.name ?? "-"}
                                                                        </Typography>
                                                                        <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                                            <Typography
                                                                                variant="body_500"
                                                                                sx={(theme: Theme) => ({
                                                                                    lineHeight: "20px",
                                                                                    letterSpacing: "0.02px",
                                                                                    color: theme.palette.text.secondary
                                                                                })}
                                                                            >
                                                                                {userDetails?.status ?? "-"}
                                                                            </Typography>
                                                                            <Box sx={(theme: Theme) => ({
                                                                                background: theme.palette.grey[400],
                                                                                borderRadius: '50%',
                                                                                width: '5px',
                                                                                height: '5px'
                                                                            })} />
                                                                            <Typography
                                                                                variant="body_500"
                                                                                sx={(theme: Theme) => ({
                                                                                    lineHeight: "20px",
                                                                                    letterSpacing: "0.02px",
                                                                                    color: theme.palette.text.secondary
                                                                                })}
                                                                            >
                                                                                {userDetails?.accountType ?? "-"}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        rowGap: "12px"
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            columnGap: "11px",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        <EmailIcon />
                                                                        <Typography
                                                                            variant="body_500"
                                                                            sx={(theme: Theme) => ({
                                                                                lineHeight: "20px",
                                                                                letterSpacing: "0.02px",
                                                                                color: theme.palette.text.primary
                                                                            })}
                                                                        >
                                                                            {userDetails?.email ?? "-"}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            columnGap: "11px",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        <Phoneicon />
                                                                        <Typography
                                                                            variant="body_500"
                                                                            sx={(theme: Theme) => ({
                                                                                lineHeight: "20px",
                                                                                letterSpacing: "0.02px",
                                                                                color: theme.palette.text.primary
                                                                            })}
                                                                        >
                                                                            {userDetails?.mobile ?? "-"}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                    <LoadingButton
                                                        fullWidth
                                                        loadingPosition="start"
                                                        type="submit"
                                                        variant="contained"
                                                        sx={(theme: Theme) => ({
                                                            ...theme.typography.body_500,
                                                            fontWeight: 700,
                                                            lineHeight: "22.5px",
                                                            letterSpacing: "0.02px",
                                                            color: theme.palette.textDark.primary,
                                                            borderRadius: "10px",
                                                            padding: "13px 56px",
                                                            boxShadow: "none",
                                                            backgroundColor: theme.palette.primary[500],
                                                        })}
                                                    >
                                                        Submit
                                                    </LoadingButton>
                                                </Box>
                                            </>
                                        </Grid>
                                    </Grid>
                                </Form>
                                <TransactionsDocumentUpload
                                    open={isDocumentUploadDialogVisible}
                                    onClose={handleDocumentUploadDialogClose}
                                />
                            </>
                        )
                    }
                }
            </Formik>

            <ConfirmationDialog
                title="Confirm Pause!"
                open={sipDialogStatus.isPauseConfirm}
                onCancel={() => setSipDialogStatus(prev => ({
                    ...prev,
                    isPauseConfirm: false
                }))}
                onConfirm={handleConfirmPause}
                isLoading={pauseLoading || otpLoading}
            />
            <SuccessDialog
                open={sipDialogStatus.isPauseSipSuccessOpen}
                handleClick={handleSuccessPauseSIP}
                content={pauseCancelResponse?.message ?? ""}
            />
            {/* Pause SIP Error Dialog */}
            <ErrorDialog
                open={sipDialogStatus.isPauseSipErrorOpen}
                content={pauseCancelResponse?.message ?? ""}
                handleClick={handleErrorPauseSIP}
            />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}
        </>
    )
}


